import { http } from '@/http';
import { SET_OPERACAO, SET_OPERACAO_FROM_API } from "./types";

export default {

    async [SET_OPERACAO_FROM_API]( { commit }, numeroOperacao) {
        const uri = `/api/OperacoesFinanceiras/Captacoes/CaptacaoEmAberto/${numeroOperacao}`
        
        const response = await http.get(uri)
            .then( response => {
                if ( response.status === 200 ) {
                    commit('setOperacao', response.data);
                    return Promise.resolve(response);
                } else {
                    return Promise.reject(response);
                }
            }
        )
            .catch ( (e) => {
                const error = {
                    status: e.status,
                    message: e.message,
                }

                error.message = e.status === 404 ? e.message.errorCode : e.message;
                error.message = e.status === 404 ? "error.load" : e.message;

                return Promise.reject({ error });
                
            }
        )

        return response;

    },

    [SET_OPERACAO] ( { commit }, operacao){
        commit ('setOperacao', operacao)
    }

}